import * as z from "zod"

export const SpaceThemeSchema = z.object({
    id: z.string(),
    name: z.string(),
    isInternal: z.boolean().nullish(),
})

export type SpaceTheme = z.TypeOf<typeof SpaceThemeSchema>
